import { oss } from "@/utils/aliyunoss";
import request from "@/utils/request.js";

// 账号密码登录
export const AccountLogin = function (data) {
  return request.post("/auth/account-login", data);
};
// 手机号验证码登录
export const MobileLogin = function (data) {
  return request.post("/auth/mobile-login", data);
};
export const LoginByOpenid = function (data) {
  return request.post("/auth/openid-login", data);
};
//账号注册
export const Register = function (data) {
  return request.post("/account/register", data);
};
export const GetWechatPublicQrcode = function (data) {
  return request.get("/util/get-wechat-qrcode", data);
};
export const QueryOpenId = function (data) {
  return request.get("/util/query-openid", data);
};
export const QueryWechat = function (data) {
  return request.post("/util/query-wechat", data);
};

// 登陆账号信息
export const Profile = function (data) {
  return request.get("/account/profile", data);
};
export const ProfileNoAuth = function (data) {
  return request.get("/account/profile2", data);
};
// 重置登录密码
export const ResetPassword = function (data) {
  return request.post("/auth/reset-password", data);
};
// 保存个人资料
export const SaveProfile = function (data) {
  return request.post("/account/save-profile", data);
};
// 修改密码
export const RevisePassword = function (data) {
  return request.post("/account/revise-password", data);
};
export const GetUserBank = function (data) {
  return request.get("/user/getBank", data);
};
export const SaveUserBank = function (data) {
  return request.post("/user/saveBank", data);
};

// 地址管理
export const AddressList = function (data) {
  return request.get("/address/list", data);
};
export const GetAddress = function (data) {
  return request.get("/address/get", data);
};
export const SaveAddress = function (data) {
  return request.post("/address/save", data);
};
export const DeleteAddress = function (data) {
  return request.post("/address/delete", data);
};
export const SetDefaultAddress = function (data) {
  return request.post("/address/set-default", data);
};

// 用户品牌相关
export const CreateUserBrand = function (data) {
  return request.post("/user-brand/create", data);
};
export const UpdateUserBrand = function (data) {
  return request.post("/user-brand/create", data);
};
export const JoinUserBrand = function (data) {
  return request.post("/user-brand/join", data);
};
export const LeaveUserBrand = function (data) {
  return request.post("/user-brand/leave", data);
};

// 款式草稿相关
export const GetDraft = function (data) {
  return request.get("/draft/get", data);
};
export const GetDraftByUUID = function (data) {
  return request.get("/draft/getByUUID", data);
};
export const SaveDraft = function (data) {
  return request.post("/draft/save", data);
};
export const DraftList = function (data) {
  return request.get("/draft/list", data);
};
export const DeleteDraft = function (data) {
  return request.post("/draft/delete", data);
};
// 设计相关
export const ProductCategoryList = function (data) {
  return request.get("/util/product_category", data);
};
export const GetDesign = function (data) {
  return request.get("/design/get", data);
};
export const GetDesignByUUID = function (data) {
  return request.get("/design/getByUUID", data);
};
export const SaveDesign = function (data) {
  return request.post("/design/save", data);
};
export const DesignList = function (data) {
  return request.get("/design/list", data);
};
export const DesignCount = function (data) {
  return request.get("/design/count", data);
};
export const DeleteDesign = function (data) {
  return request.post("/design/delete", data);
};
export const CopyDesignToDraft = function (data) {
  return request.post("/design/copy", data);
};
export const StoreDesign = function (data) {
  return request.post("/design/store", data);
};
export const getPriceList = function (data) {
  return request.get("/design/price-list", data);
};

export const getDesignCateList = function(data){
  return request.get('/design/design-cate',data);
}
export const PatternSetting = function (data) {
  return request.get("/pattern/setting", data);
};
export const PatternCategoryList = function (data) {
  return request.get("/pattern/category", data);
};
export const PatternLabelList = function (data) {
  return request.get("/pattern/label", data);
};
export const PatternList = function (data) {
  return request.get("/pattern/list", data);
};
export const FabricCategoryList = function (data) {
  return request.get("/fabric/category", data);
};
export const FabricLabelList = function (data) {
  return request.get("/fabric/label", data);
};
export const FabricList = function (data) {
  return request.get("/fabric/lists", data);
};
export const GetFabric = function (data) {
  return request.get("/fabric/get", data);
};

export const AccessoryCategoryList = function (data) {
  return request.get("/accessory/category", data);
};
export const AccessoryLabelList = function (data) {
  return request.get("/accessory/label", data);
};
export const AccessoryList = function (data) {
  return request.get("/accessory/lists", data);
};
export const GetAccessory = function (data) {
  return request.get("/accessory/get", data);
};
// 获取印绣花工艺
export const GetYXTech = function (data) {
  return request.get("/tech_library/lists", data);
};
export const GetSpecialTech = function (data) {
  return request.get("/tech_library/special_list", data);
};

//发送验证码
export const SendSms = function (data) {
  return request.post("/util/sms", data);
};
// 验证短信验证码
export const CheckSms = function (data) {
  return request.post("/util/check-sms", data);
};
export const CheckCode = function (data) {
  return request.post("/util/check-code", data);
};
export const RecordVisit = function (data) {
  return request.post("/util/recordVisit", data);
};

// 商品相关
export const SaveProduct = function (data) {
  return request.post("/product/save", data);
};
export const GetProduct = function (data) {
  return request.get("/product/get", data);
};
export const ProductList = function (data) {
  return request.get("/product/list", data);
};
export const UserProductCategoryList = function (data) {
  return request.get("/product/category", data);
};

export const ProductUnsale = function (data) {
  return request.post("/product/unsale", data);
};

export const ProductOnsale = function (data) {
  return request.post("/product/onsale", data);
};

export const ProductDelete = function (data) {
  return request.post("/product/delete", data);
};

export const ProductCount = function (data) {
  return request.get("/product/count", data);
};
export const SetCommission = function (data) {
  return request.post("/product/set-commission", data);
};

// 订单相关
export const PoColor = function (data) {
  return request.get("/util/pocolor", data);
};
export const CreateOrder = function (data) {
  return request.post("/order/create", data);
};
export const OrderList = function (data) {
  return request.get("/order/list", data);
};
export const OrderCount = function (data) {
  return request.get("/order/count", data);
};
export const OrderDetail = function (data) {
  return request.get("/order/detail", data);
};
export const CheckoutOrder = function (data) {
  return request.post("/order/checkout", data);
};
export const PayOrder = function (data) {
  return request.post("/order/pay", data);
};
export const MakeupOrder = function (data) {
  return request.post("/order/makeup", data);
};
export const SendFabric = function (data) {
  return request.post("/order/send-fabric", data);
};
export const CheckPayStatus = function (data) {
  return request.get("/pay/status", data);
};
export const ConfirmOrder = function (data) {
  return request.post("/order/confirm", data);
};
export const CancelOrder = function (data) {
  return request.post("/order/cancel", data);
};
export const GetOrderByPoNo = function (data) {
  return request.get("/order/detail-by-po", data);
};
export const GetOrderByCapture = function (data) {
  return request.get("/order/detail-by-capture", data);
};
export const ChangeExpedited = function (data) {
  return request.post("/order/change-expedited", data);
};
export const ChangeTryPattern = function (data) {
  return request.post("/order/change-try-pattern", data);
};

export const addUserContribution = function (data) {
  return request.post("/util/addUserContribution", data);
};
export const MtmFields = function (data) {
  return request.get("/util/mtm_fields", data);
};
//>首页
export const GetBannerList = function (data) {
  return request.get("/banner/list", data);
};
export const AddBannerStat = function (data) {
  return request.get("/banner/addStat", data);
};

//>帖子分类
export const GetCategoryList = function (data) {
  return request.get("/category/list", data);
};

//>资讯
export const GetNewsCateList = function (data) {
  return request.get("/info/sub_menu", data);
};

//获取PC配置
export const getSetting = function (data) {
  return request.get("/util/setting", data);
};

//>搜索结果
export const SearchResult = function (data) {
  return request.post("/search/list", data);
};

//阿里云OSS
export const getOssToken = function (data) {
  return request.get("/util/get-oss-token", data);
};
//银行
export const GetBankList = function (data) {
  return request.get("/util/get-bank-info", data);
};
//支行
export const GetBranchList = function (data) {
  return request.get("/util/get-branch-info", data);
};

//银行地址
export const GetBankArea = function (data) {
  return request.get("/util/get-branch-area", data);
};

// OSS前端直传
export const uploadOss = async function (file, options = {}) {
  let config = await oss(file.name);
  let data = { ...config, file };
  let newParams = new FormData();
  for (let i in data) {
    newParams.append(i, data[i]);
  }
  options = {
    ...options,
    headers: {
      "Content-Type": "multipart/form-data",
      "api-usage": "oss",
    },
  };
  await request.post(config.host, newParams, options);
  return config.oss_url + config.key;
};

// 文件后端上传
export const uploadFile = async function (file, dir, options = {}) {
  let data = { dir, file };
  let newParams = new FormData();
  for (let i in data) {
    newParams.append(i, data[i]);
  }
  options = {
    ...options,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return await request.post("/util/upload-image", newParams, options);
};

//>新首页-分类菜单
export const getNewIndexCate = function (data) {
  return request.get("/info/index-category", data);
};

//>合作案例-案例列表
export const getCooperationList = function (data) {
  return request.get("/cases/cases-list", data);
};

//>评价-评价列表
export const getEvaluationList = function (data) {
  return request.get("/cases/evaluation-list", data);
};

//>案例详情
export const getCaseDetail = function (data) {
  return request.get("/cases/detail", data);
};

//>申请开票
export const applyTax = function(data){
  return request.post("/order/apply-tax",data);
}

//>获取历史版型
export const getPatternHistory = function(data){
  return request.get('/pattern/history-list',data);
}

//>历史面料
export const getDesignHistory = function(data){
  return request.get('/design/history-data',data);
}

export const updateImgList = function(data){
	return request.post('/draft/updateImgList',data)
}

export const createRechargeOrder = function(data){
  return request.get('/user/user-recharge',data);
}

export const rechargePay = function(data){
  return request.post('/recharge/pay',data);
}

export const getBalanceLog = function(data){
  return request.get('/user/balance-log',data);
}
export const getPointLog = function(data){
  return request.get('/user/point-log',data);
}

export const getCouponLog = function(data){
  return request.get('/user/coupon-log',data);
}

export const collectTemp = function(data){
  return request.post('/user/template-collection',data);
}

//>店铺申请
export const shopApply = function(data){
  return request.post('/shop/apply',data);
}
//>店铺申请信息
export const getShopApplyInfo = function(data){
  return request.get('/shop/get-apply',data);
}
/**
 * 商城相关开始
 */

//>商城商品列表-分类
export const getMallCategoryList = function(data){
  return request.get('/product/mall/category',data);
}

//>商城商品列表
export const getMallProductList = function(data){
  return request.get('/product/mall/list',data);
}

//>商城商品详情
export const getMallProductDetail = function(data){
  return request.get('/product/mall/detail',data);
}

//>添加购物车
export const addCart = function(data){
  return request.post('/cart/add',data);
}

//>购物车调整(增减)
export const cartChange = function(data){
  return request.post('/cart/change_num',data);
}

//>移除购物车
export const cartDelete = function(data){
  return request.post('/cart/delete',data);
}

//>购物车列表
export const getCartList = function(data){
  return request.get('/cart/list',data);
}

//>规格库存
export const getSkuStock = function(data){
  return request.get('/product/mall/spec',data);
}

//>商品规格数据
export const productSpecList = function(data){
  return request.get('/product/mall/spec_group',data);
}

//>商品库存查询
export const productSpecStock = function(data){
  return request.get('/product/mall/spec_stock',data);
}

//>购物车商品规格修改
export const cartSpecChange = function(data){
  return request.post('/cart/change_spec',data);
}

//>首页精选分类
export const indexCate = function(data){
  return request.get('/product/mall/index_cate',data);
}

//>商品收藏
export const productCollect = function(data){
  return request.post('/product/mall/collect',data);
}

//>设计师列表
export const designerList = function(data){
  return request.get('/mall/designer-list',data);
}

//>购物车计数
export const cartCount = function(data){
  return request.get('/user/cart-count',data);
}

//>收藏商品列表
export const collectProductList = function(data){
  return request.get('/mall/collect-product-list',data);
}

/**
 * 订单估价
 * @param {Object} data - 请求参数对象
 * @param {String} data.address_id - 地址ID
 * @param {String} data.from - 来源场景(cart:购物车,buynow:立即购买)
 * @param {Array} data.cart_uuid - 购物车uuid(仅场景值cart需要)
 * @param {String} data.spec_id - 规格ID值(场景值buynow必传)
 * @param {String} data.num - 购买数量(场景值buynow需要)
 * @returns {Promise<Object>} 返回结果
 */
export const orderEstimate = function(data){
  return request.post('/order/mall/estimate',data);
}

/**
 * 创建订单
 * @param {Object} data - 请求参数对象
 * @param {String} data.address_id - 地址ID
 * @param {String} data.from - 来源场景(cart:购物车,buynow:立即购买)
 * @param {Array} data.cart_uuid - 购物车uuid(仅场景值cart需要)
 * @param {String} data.spec_id - 规格ID值(场景值buynow必传)
 * @param {String} data.num - 购买数量(场景值buynow需要)
 * @returns {Promise<Object>} 返回结果
 */
export const createOrder = function(data){
  return request.post('/order/mall/create',data);
}

/**
 * 确认订单
 * @param {Object} data - 请求参数对象
 * @param {String} data.address_id - 地址ID
 * @param {Array} data.uuid - 创建订单返回的UUID
 * @returns {Promise<Object>} 返回结果
 */
export const orderCheckout = function(data){
  return request.post('/order/mall/checkout',data);
}

/**
 * 订单支付
 * @param {Object} data - 支付参数对象
 * @param {String} data.trade_no - 交易订单号
 * @param {String} data.pay_type - 支付方式 (wechat:PC微信扫码支付,miniapp:小程序支付,alipay:支付宝支付)
 * @returns {Promise<Object>} 返回支付结果
 */
export const orderPay = function(data){
  return request.post('/order/mall/pay',data);
}
//>支付结果
export const GetPayResult = function(data){
  return request.get('/order/mall/pay-result',data);
}

/**
 * 支付状态查询
 * @param {Object} data - 支付参数对象
 * @returns
 */
export const CheckMallPayStatus = function (data) {
  return request.get("/pay/status2", data);
};

//>订单列表
export const MallOrderList = function(data){
  return request.get('/order/mall/list',data);
}

//>订单列表计数(tab显示)
export const MallOrderCount = function(data){
  return request.get('/order/mall/count',data);
}

//>订单分类列表
export const MallOrderCateList = function(data){
  return request.get('/order/mall/order-cate-list',data);
}

//>确认页商品详情
export const MallDetailInCheckout = function(data){
  return request.get('/order/mall/detail-in-checkout',data);
}


//>确认收货
export const MallConfirmOrder = function(data){
  return request.post('/order/mall/confirm',data);
}

//>取消订单
export const MallCancelOrder = function(data){
  return request.post('/order/mall/cancel',data);
}

//>订单详情
export const MallOrderDetail = function(data){
  return request.get('/order/mall/detail',data);
}

//>关注/取关店铺
export const MallShopCollect = function(data){
  return request.post('/user/toggle-collect-shop',data);
}

//>发布评价
export const MallComment = function(data){
  return request.post('/product/mall/comment',data);
}

//>评价列表
export const MallCommentList = function(data){
  return request.get('/product/mall/comments',data);
}

//>回复评价
export const MallCommentReply = function(data){
  return request.post('/product/mall/reply',data);
}

//>评价/回复-点赞
export const MallCommentLike = function(data){
  return request.post('/product/mall/comment-zan',data);
}

/**
 * 批量加入购物车
 * @param {Object} data - 请求参数对象
 * @param {Array[String]} data.uuid - 请求参数uuid数组
 * @returns {Object<Promise>} 请求结果
 */
export const CartBatchAdd = function(data){
  return request.post('/cart/batch-add',data);
}

/**
 * 批量取消收藏
 * @param {Object} data - 请求参数对象
 * @param {Array[String]} data.uuid - 请求参数UUID
 * @returns {Object<Promise>} 请求结果
 */
export const CollectBatchCancel = function(data){
  return request.post('/product/mall/batch-collect',data);
}


/**
 * 发起售后
 * @param {Object} data - 售后参数对象
 * @param {String} data.order_uuid - 订单uuid
 * @param {String} data.goods_uuid - 商品uuid
 * @param {String} data.type - 售后类型(1:退货退款,2:换货)
 * @param {String} data.reason - 售后原因
 * @param {Array[String]} data.user_proof - 用户上传凭证
 * @param {String} data.user_memo - 用户备注
 * @param {String} data.money - 申请退款金额
 * @param {String} data.new_spec_id - 新规格ID
 * @returns {Promise<Object>} 售后结果
 */
export const AfterSaleApply = function(data){
  return request.post('/order/mall/apply-refund',data);
}

/**
 * 修改售后
 * @param {Object} data - 售后参数对象
 * @param {String} data.service_uuid - 售后订单UUID
 * @param {String} data.reason - 售后原因
 * @param {Array[String]} data.user_proof - 用户上传凭证
 * @param {String} data.user_memo - 用户备注
 * @param {String} data.money - 申请退款金额
 * @param {String} data.new_spec_id - 新规格ID
 * @returns {Promise<Object>} 修改结果
 */
export const ModifyServiceApply = function(data){
  return request.post('/order/mall/revise-refund',data);
}

/**
 * 寄回商品
 * @param {Object} data - 售后参数对象
 * @param {String} data.uuid - 订单uuid
 * @param {String} data.logistics_id - 物流ID
 * @param {String} data.logistics_no - 运单号
 * @returns {Promise<Object>} 寄回商品结果
 */
export const AfterSaleReturn = function(data){
  return request.post('/order/mall/send-back',data);
}

/**
 * 确认换货完成
 * @param {Object} data - 售后参数对象
 * @param {String} data.uuid - 订单uuid
 * @returns {Promise<Object>} 确认换货完成结果
 */
export const AfterSaleConfirm = function(data){
  return request.post('/order/mall/agree-resend',data);
}

/**
 * 取消售后
 * @param {Object} data - 售后参数对象
 * @param {String} data.uuid - 订单uuid
 * @returns {Promise<Object>} 取消售后结果
 */
export const AfterSaleCancel = function(data){
  return request.post('/order/mall/cancel-service',data);
}

/**
 * 售后详情
 * @param {Object} data - 售后参数对象
 * @param {String} data.uuid - 售后订单UUID
 * @returns {Promise<Object>} 售后详情结果
 */
export const AfterSaleDetail = function(data){
  return request.get('/order/mall/service-detail',data);
}


/**
 * 批发-加入购物车
 * @param {Array<Object>} data - 请求参数对象
 * @param {Object} [{spec_id,num}]- 批发商品参数数组,spec_id:规格ID,num:数量
 * @returns {Object<Promise>} 添加结果
 */
export const WholesaleAddCart = function(data){
  return request.post('/cart/add-wholesale',data);
}

/**
 * 获取客户服务列表
 */
export const GetCustomerServiceList = function(){
  return request.get('/mall/custom-service-list');
}
/**
 * 商城相关结束
 */

/**
 * 团队相关接口开始
 */

/**
 * 创建团队
 * @param {Object} data - 创建团队参数对象
 * @param {String} data.name - 团队名称
 * @param {String} data.image - 团队图标
 * @param {String} data.description - 团队描述
 * @returns {Promise<Object>} 返回支付结果
 */
export const createTeam = function(data){
  return request.post('/user-team/create',data);
}

/**
 * 团队信息更新
 * @param {Object} data - 团队信息更新参数对象
 * @param {String} data.uuid - 团队唯一标识符
 * @param {String} data.name - 团队名称
 * @param {String} data.image - 团队图标
 * @param {String} data.description - 团队描述
 * @returns {Promise<Object>} 团队信息更新结果
 */
export const updateTeam = function(data){
  return request.post('/user-team/update',data);
}

/**
 * 解散团队
 * @param {Object} data - 解散团队参数对象
 * @param {String} data.uuid - 团队唯一标识符
 * @returns {Promise<Object>} 解散团队结果
 */
export const disbandTeam = function(data){
  return request.post('/user-team/dismiss',data);
}

/**
 * 邀请成员
 * @param {Object} data - 邀请成员参数对象
 * @param {String} data.uuid - 团队唯一标识符
 * @param {Array<String>} data.members - 邀请成员手机号
 * @returns {Promise<Object>} 邀请结果
 */
export const inviteMembers = function(data){
  return request.post('/user-team/invite',data);
}

/**
 * 移除成员
 * @param {Object} data - 移除成员参数对象
 * @param {String} data.uuid - 团队唯一标识符
 * @param {String} data.user_id - 成员ID
 * @returns {Promise<Object>} 移除结果
 */
export const removeMember = function(data){
  return request.post('/user-team/remove',data);
}

/**
 * 退出团队
 * @param {Object} data - 退出团队参数对象
 * @param {String} data.uuid - 团队唯一标识符
 * @returns {Promise<Object>} 退出结果
 */
export const quitTeam = function(data){
  return request.post('/user-team/leave',data);
}

/**
 * 团队列表
 * @param {Object} data - 团队列表参数对象
 * @param {String} data.page - 页码/预留参数
 * @param {String} data.size - 每页数量/预留参数
 * @returns {Promise<Object>} 团队列表结果
 */
export const teamList = function(data){
  return request.get('/user-team/lists',data);
}

/**
 * 团队成员列表
 * @param {Object} data - 团队成员列表参数对象
 * @param {String} data.uuid - 团队ID
 * @param {String} data.page - 页码/预留参数
 * @param {String} data.size - 每页数量/预留参数
 * @returns {Promise<Object>} 团队成员列表结果
 */
export const teamMemberList = function(data){
  return request.get('/user-team/member-lists',data);
}

/**
 * 团队成员备注修改
 * @param {Object} data - 团队成员备注修改参数对象
 * @param {String} data.uuid - 团队ID
 * @param {String} data.member_id - 团队成员ID
 * @param {String} data.alias - 团队成员备注
 * @returns {Promise<Object>} 团队成员备注修改结果
 */
export const teamMemberAlias = function(data){
  return request.post('/user-team/modify-member-alias',data);
}

/**
 * 团队目录/文件列表
 * @param {Object} data - 团队目录/文件列表参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.parent_directory_uuid - 父级目录uuID,传空为获取根目录文件夹及文件
 * @returns {Promise<Object>} 团队目录/文件列表结果
 */
export const teamFolderFileList = function(data){
  return request.get('/team-file/lists',data);
}

/**
 * 创建文件夹
 * @param {Object} data - 创建文件夹参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.name - 文件夹名称
 * @param {String} data.is_visible - 是否可见 1:公开,0:仅自己可见
 * @param {String} data.parent_directory_uuid - 父级目录ID(可选参数)
 */
export const teamFolderCreate = function(data){
  return request.post('/team-file/create-directory',data);
}

/**
 * 更新文件夹
 * @param {Object} data - 更新文件夹参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.directory_uuid - 文件夹ID
 * @param {String} data.name - 文件夹名称
 * @param {String} data.is_visible - 是否可见 1:公开
 * @returns {Promise<Object>} - 响应数据
 */
export const teamFolderUpdate = function(data){
  return request.post('/team-file/update-directory',data);
}

/**
 * 删除文件夹
 * @param {Object} data - 删除文件夹参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.directory_uuid - 文件夹ID
 * @returns {Promise<Object>} - Promise对象，表示删除文件夹操作的异步结果
 */
export const teamFolderDelete = function(data){
  return request.post('/team-file/delete-directory',data);
}

/**
 * 创建文件
 * @param {Object} data - 创建文件参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.directory_uuid - 文件夹ID
 * @param {String} data.type - 文件类型 51:版型,52:面料,53:辅料,54:普通文件
 * @param {Object} data.info - 文件信息对象
 */
export const teamFileCreate = function(data){
  return request.post('/team-file/create-file',data);
}

/**
 * 修改文件
 * @param {Object} data - 文件信息对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.file_uuid - 文件ID
 * @param {String} data.type - 文件类型 51:版型,52:面料,53:辅料,54:普通文件
 * @param {Object} data.info - 文件信息对象
 */
export const teamFileUpdate = function(data){
  return request.post('/team-file/update-file',data);
}

/**
 * 删除文件
 * @param {Object} data - 文件信息对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.file_uuid - 文件ID
 */
export const teamFileDelete = function(data){
  return request.post('/team-file/delete-file',data);
}

/**
 * 移动文件
 * @param {Object} data - 文件信息对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.file_uuid - 文件ID
 * @param {String} data.parent_directory_uuid - 上级文件夹UUID
 * @param {String} data.type - 文件类型
 * @param {Object} data.info - 文件信息
 * @returns {Promise<Object>} - 移动文件结果
 */
export const teamFileMove = function(data){
  return request.post('/team-file/move-file',data);
}

/**
 * 从历史导入[版型/面料/辅料]
 * @param {Object} data - 请求参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.type - 文件类型 51版型,52面料,53辅料
 * @returns {Promise<Object>} - 导入操作结果
 */
export const teamFileImport = function(data){
  return request.post('/team-file/import-history',data);
}

/**
 * 文件详情(仅平台版型/面辅料)
 * @param {Object} data - 文件详情参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.file_uuid - 文件UUID
 * @param {String} data.file_id - 文件ID[版型传pattern_id,面料传fabric_key,辅料传accessory_sku]
 * @returns {Promise<Object>} - 文件详情结果
 */
export const teamFileDetail = function(data){
  return request.get('/team-file/file-detail',data);
}

/**
 * 款式设计 - 文件列表
 * @param {Object} data - 文件列表请求参数
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.folder_uuid - 文件夹ID
 * @returns {Promise<Object>} - 文件列表结果
 */
export const teamFileListForDesgin = function(data){
  return request.get('/team-file/design-file-list',data);
}

/**
 * 款式设计 - tab文件统计
 * @param {Object} data - 请求参数对象
 * @param {String} data.team_uuid - 团队ID
 * @param {String} data.folder_uuid - 文件夹ID
 * @returns {Promise<Object>} - 请求结果
 */
export const folderFileCount = function(data){
  return request.get('/team-file/design-file-count',data);
}

/**
 * 团队相关接口结束
 */


/**
 * 版师入驻接口开始
 */

export const categoryList = function(data){
  return request.get('/product/category4pm',data);
}

export const applyPM = function(data){
  return request.post('/user/pattern-maker-register',data);
}

export const patternMakerInfo = function(data){
  return request.get('/user/pattern-maker-info',data);
}

/**
 * 版师入驻接口结束
 */

/**
 * 店铺管理相关接口开始
 */

export const shopInfo = function(data){
  return request.get('/shop/info',data);
}

/**
 * 店铺信息
 * @param {Object} data - 店铺信息参数对象
 * @param {String} data.uuid - 店铺ID
 * @returns {Promise<Object>} - 店铺信息结果
 */

/**
 * 店铺订单列表
 * @param {Object} data - 订单列表参数对象
 * @param {String} data.status - 订单状态[wait_pay,wait_delivery,wait_confirm,in_service(售后中),complete,cancel,close,all]
 * @param {String} data.page - 页码
 * @param {String} data.size - 每页数量
 * @param {String} data.keyword - 搜索关键字
 * @returns
 */
export const shopOrderList = function(data){
  return request.get('/order/owner/lists',data);
}

/**
 * 店铺订单列表
 * @param {Object} data - 订单列表参数对象
 * @param {String} data.status - 订单状态[wait_pay,wait_delivery,wait_confirm,in_service(售后中),complete,cancel,close,all]
 * @param {String} data.page - 页码
 * @param {String} data.size - 每页数量
 * @param {String} data.keyword - 搜索关键字
 * @returns
 */
export const shopServiceOrderList = function(data){
  return request.get('/order/owner/service-lists',data);
}

/**
 * 订单详情
 * @param {Object} data - 订单详情参数对象
 * @param {String} data.uuid - 订单ID
 * @returns
 */
export const shopOrderDetail = function(data){
  return request.get('/order/owner/detail',data);
}

/**
 * 订单列表计数
 * @param {Object} data - 订单计数参数对象
 * @param {String} data.status - 订单状态[wait_pay,wait_delivery,wait_confirm,in_service(售后中),complete,cancel,close,all]
 * @param {String} data.keyword - 搜索关键字
 * @returns
 */
export const shopOrderListCount = function(data){
  return request.get('/order/owner/count',data);
}

/**
 * 订单备注
 * @param {Object} data - 订单备注参数对象
 * @param {String} data.order_id - 订单ID
 * @param {String} data.color - 颜色[red,blue,yellow,green]
 * @param {String} data.memo - 备注内容
 * @returns
 */
export const shopOrderRemark = function(data){
  return request.post('/order/owner/set-flag',data);
}

/**
 * 订单发货
 * @param {Object} data - 订单发货参数对象
 * @param {String} data.uuid - 订单ID
 * @param {Array} data.goods_ids - 商品ID列表
 * @param {String} data.logistics_id - 物流公司ID
 * @param {String} data.logistics_no - 物流单号
 * @param {String} data.memo - 发货备注
 * @returns
 */
export const shopOrderDelivery = function(data){
  return request.post('/order/owner/send',data);
}

/**
 * 获取物流公司列表
 * @param {Object} data - 物流公司列表请求参数
 * @returns
 */
export const logisticsCompanyList = function(data){
  return request.get('/util/wuliu',data);
}

/**
 * 同意售后申请
 * @param {Object} data - 参数对象
 * @param {String} data.uuid - 售后申请ID
 * @param {String} data.money - 同意售后申请金额
 * @param {String} data.shop_memo - 同意售后申请备注
 * @returns
 */
export const afterSaleApplyAgree = function(data){
  return request.post('/order/owner/agree-apply',data);
}

/**
 * 拒绝售后申请
 * @param {Object} data - 拒绝售后申请参数对象
 * @param {String} data.uuid - 售后申请ID
 * @param {String} data.shop_reason - 拒绝售后申请原因
 * @param {Array[String]} data.shop_proof - 拒绝售后申请凭证图片
 * @param {String} data.shop_memo - 拒绝售后申请备注
 * @returns
 */
export const afterSaleApplyReject = function(data){
  return request.post('/order/owner/reject-apply',data);
}

/**
 * 确认用户寄回商品
 * @param {Object} data - 确认用户寄回商品参数对象
 * @param {String} data.uuid - 售后申请ID
 * @returns
 */
export const receiveExchangeGoods = function(data){
  return request.post('/order/owner/agree-receive',data);
}

/**
 * 拒绝用户寄回商品
 * @param {Object} data - 拒绝售后申请参数对象
 * @param {String} data.uuid - 售后申请ID
 * @param {String} data.shop_reason - 拒绝售后申请原因
 * @param {Array[String]} data.shop_proof - 拒绝售后申请凭证图片
 * @param {String} data.shop_memo - 拒绝售后申请备注
 * @returns
 */
export const rejectExchangeGoods = function(data){
  return request.post('/order/owner/reject-receive',data);
}

/**
 * 寄出换货商品
 * @param {Object} data - 寄出换货商品参数对象
 * @param {String} data.uuid - 售后申请ID
 * @param {String} data.logistics_id - 物流公司ID
 * @param {String} data.logistics_no - 物流单号
 * @returns
 */
export const sendExchangeGoods = function(data){
  return request.post('/order/owner/resend',data);
}

/**
 * 店铺信息修改
 * @param {Object} data - 店铺信息修改参数对象
 * @param {String} data.field - 修改类型-base:基本,return_address:退货地址,express:物流公司,card:收款信息
 * @param {String} data.shop_name - 店铺名称
 * @param {String} data.logo - 店铺logo
 * @param {Array[String]} data.label - 店铺标签
 * @param {String} data.shop_desc - 店铺描述
 * @param {String} data.card_type - 卡类型:1:对私,2:对公
 * @param {String} data.card_bank - 银行名称
 * @param {String} data.card_no - 银行卡号
 * @param {String} data.card_mobile - 银行预留电话
 */

export const shopInfoUpdate = function(data){
  return request.post('/shop/update-info',data);
}


/**
 * 店铺资产信息
 * @param {Object} data - 店铺资产信息参数对象
 * @returns
 */
export const shopAssetsInfo = function(data){
  return request.get('/user/account',data);
}

/**
 * 店铺统计
 * @param {Object} data - 店铺统计参数对象
 * @param {String} data.range - 统计区间[今天today,近1天yesterday,近7天week,近30天month]
 * @returns
 */
export const shopStatistics = function(data){
  return request.get('/shop/stat',data);
}

/**
 * 店铺账户明细
 */
export const shopAccountBalanceLog = function(data){
  return request.get('/shop/balancelog',data);
}

/**
 * 店铺账户申请提现
 * @param {Object} data - 申请提现对象
 * @param {String} data.money - 提现金额
 * @param {String} data.code - 验证码
 * @returns
 */
export const shopApplyWithdraw = function(data){
  return request.post('/shop/withdraw',data);
}

/**
 * 支付账户申请提现
 * @param {Object} data - 申请提现对象
 * @param {String} data.money - 提现金额
 * @param {String} data.code - 验证码
 * @returns
 */
export const payApplyWithdraw = function(data){
  return request.post('/user/withdraw',data);
}

/**
 * 店铺提现记录
 * @param {Object} data - 提现记录参数对象
 * @param {String} data.range - 区间[今天today,近1天yesterday,近7天week,近30天month]
 * @returns
 */
export const shopWithdrawLog = function(data){
  return request.get('/shop/withdrawlog',data);
}

/**
 * 店铺管理相关接口结束
 */


/**
 * 版师订单接口开始
 */
export const GetOrderMakeList = function(data){
  return request.get('/order-make/lists',data);
}
export const GetOrderMakeCount = function(data){
  return request.get('/order-make/count',data);
}
export const GetOrderMakeDetail = function(data){
  return request.get('/order-make/detail',data);
}
export const OrderMakeAccept = function(data){
  return request.post('/order-make/accept',data);
}
export const OrderMakeReject = function(data){
  return request.post('/order-make/reject',data);
}
export const OrderMakeSubmit = function(data){
  return request.post('/order-make/submit',data);
}
export const OrderMakeReupload= function(data){
  return request.post('/order-make/reupload',data);
}
export const OrderTimeout = function(data){
  return request.post('/order-make/timeout',data);
}
/**
 * 版师订单接口结束
 */

//物流轨迹
export const GetLogisticsTracking= function(data){
  return request.post('/util/getLogisticsTracking',data);
}

/**
 * 自有面辅料库接口开始
 */

/**
 * 获取自有面辅料列表
 * @param {Object} data - 获取自有面辅料列表参数对象
 * @param {String} data.page - 页码
 * @param {String} data.limit - 每页数量
 * @param {String} data.keyword - 关键字
 * @param {String} data.type - 类型[1:面料,2:辅料]
 * @param {String} data.status - 状态[99:全部,0:未入库,1:已入库]
 * @returns 
 */
export const GetOwnerMaterialList = (data)=>{
  return request.get('/customer-material/lists',data);
}

/**
 * 获取自有面辅料数量
 * @param {Object} data - 获取自有面辅料数量参数对象
 * @param {String} data.type - 类型[1:面料,2:辅料]
 * @returns 
 */
export const GetOwnerMaterialCount = (data)=>{
  return request.get('/customer-material/count',data);
}

/**
 * 获取自有面辅料详情
 * @param {Object} data - 获取自有面辅料详情参数对象
 * @param {String} data.uuid - 自有面辅料ID
 * @returns 
 */
export const GetOwnerMaterialDetail = (data)=>{
  return request.get('/customer-material/detail',data);
}


/**
 * 新增物料
 * @param {Object} data - 新增物料参数对象
 * @param {String} data.type - 类型[1:面料,2:辅料]
 * @param {String} data.no - 编号
 * @param {String} data.name - 名称
 * @param {String} data.image - 图片
 * @param {String} data.component - 成分
 * @param {String} data.weight - 克重
 * @param {String} data.wide_width - 幅宽
 * @param {Array<Object>} data.color - 颜色
 * @param {String} data.color[].name - 颜色名称
 * @param {String} data.color[].image - 颜色图片
 * @returns
 */
export const AddOwnerMaterial = (data)=>{
  return request.post('/customer-material/create',data);
}

/**
 * 删除物料
 * @param {Object} data - 删除物料参数对象
 * @param {String} data.uuid - 物料ID
 * @returns
 */
export const DeleteOwnerMaterial = (data)=>{
  return request.post('/customer-material/delete',data);
}

/**
 * 寄回物料
 * @param {Object} data - 寄回物料参数对象
 * @param {String} data.uuid - 物料ID
 * @param {String} data.memo - 备注
 * @param {String} data.logistics_company - 物流公司
 * @param {String} data.logistics_no - 物流编号
 * @param {Array/Object} data.wuliao_json - 物料图片
 * @param {String} data.wuliao_json[].color_id - 颜色ID
 * @param {String} data.wuliao_json[].send - 寄回数量
 */
export const OwnerMaterialSendBack = (data)=>{
  return request.post('/customer-material/send-back',data);
}

/**
 * 入库记录
 * @param {Object} data - 入库记录参数对象
 * @param {String} data.page - 页码
 * @param {String} data.limit - 每页数量
 * @returns
 */
export const OwnerMaterialInLog = (data)=>{
  return request.get('/customer-material/inlog',data);
}

/**
 * 使用记录
 * @param {Object} data - 使用记录参数对象
 * @param {String} data.page - 页码
 * @param {String} data.limit - 每页数量
 * @returns
 */
export const OwnerMaterialUseLog = (data)=>{
  return request.get('/customer-material/uselog',data);
}

/**
 * 修改物料
 * @param {Object} data - 修改物料参数对象
 * @param {String} data.name - 名称
 * @param {String} data.image - 图片
 * @param {String} data.component - 成分
 * @param {String} data.weight - 克重
 * @param {String} data.wide_width - 幅宽
 * @param {Array<Object>} data.color - 颜色
 * @param {String} data.color[].name - 颜色名称
 * @param {String} data.color[].image - 颜色图片
 * @param {String} data.color[].uuid - 颜色UUID
 */
export const UpdateOwnerMaterial = (data)=>{
  return request.post('/customer-material/update',data);
}

/**
 * 自有面辅料库接口结束
 */